import WorkFilesView from "@/react/components/entityViews/workfiles/WorkFilesView";

export const WorkFilesPage = () => {
  return (
    <div className="relative flex flex-1 flex-col bg-background w-full min-w-0 min-h-0" id="work-files-page">
      <div className="flex-1 min-h-0">
        <WorkFilesView />
      </div>
    </div>
  );
};

export default WorkFilesPage;
